import { FILTER_LABELS, MODELS } from '@/analytics/lib';
import { useDialogs } from './dialogs';
import { Btn, SelectWrap } from './ui';
import { FilterDialog, SaveReportDialog } from './reportDialogs';
import { windowLabel } from './data';

// The report toolbar, after the prototype: the attribution model, the channel, "Add filter" (with the active filter
// as its label), Reset, then the click window and "Save report" on the right.
const FILTER_KEYS = ['source', 'medium', 'campaign'];
export function ReportToolbar({ state, update, page, showModel = true, showSave = true, children }) {
  const { openDialog } = useDialogs();
  const sources = (state.dims?.source || []).map(o => ({ value: String(o.value), label: String(o.value) }));
  const active = FILTER_KEYS.filter(k => state.filters[k] && k !== 'source');
  const hasFilters = !!state.filters.source || active.length > 0;
  const filterLabel = active.length ? active.map(k => `${FILTER_LABELS[k]}: ${state.filters[k]}`).join(' · ') : 'Add filter';
  return (
    <div className="toolbar">
      <div className="toolbar-side">
        {showModel && <SelectWrap label="Attribution model" prefix="Attribution:" icon="target" value={state.model} options={MODELS} onChange={v => update({ model: v === 'last' ? null : v })} />}
        <SelectWrap label="Channel filter" icon="filter" value={state.filters.source || ''} options={[{ value: '', label: 'All channels' }, ...sources]} onChange={v => update({ source: v || null })} />
        <span className="toolbar-split" />
        <Btn icon="plus" onClick={() => openDialog({ title: 'Filter the report', body: <FilterDialog state={state} update={update} /> })} aria-label={active.length ? 'Edit filters' : 'Add filter'}>{filterLabel}</Btn>
        {hasFilters && <Btn ghost onClick={() => update(Object.fromEntries(FILTER_KEYS.map(k => [k, null])))}>Reset</Btn>}
        {children}
      </div>
      <div className="toolbar-side">
        <span className="muted" title="Credit is assigned to tracked ad touches inside this window before each conversion.">{windowLabel(state.window).replace('-day window', '-day click window')}</span>
        {showSave && <Btn icon="save" onClick={() => openDialog({ title: 'Save your perspective', body: <SaveReportDialog state={state} page={page} /> })}>Save report</Btn>}
      </div>
    </div>
  );
}
